import { Component, Input, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CompanyService } from 'src/app/services/company.service';
import { GlobalService } from 'src/app/services/global.service';
import { AwsSupplierManagementService } from 'src/app/services/main/home/supplier-management/aws-supplier-management.service';
@Component({
  selector: 'app-log-activity-review-global',
  templateUrl: './log-activity-review.component.html',
  styleUrl: './log-activity-review.component.scss'
})
export class LogActivityReviewGobalComponent implements OnInit{
  @Input() idSupplier = "";
  loadLog = false;
  activities = [];
  lastKey = null;
  constructor(
    private globalService: GlobalService,
    private companyService: CompanyService,
    private aws: AwsSupplierManagementService,
  ){

  }

  ngOnInit(): void {
    this.getLog();
  }

  async getLog(){
    try {
      this.loadLog = true;
      let body = { 
        idCompany:this.companyService.idCompany,
        idSupplier: this.idSupplier
      }
      let result = await firstValueFrom(this.aws.supplierManagementLog(body));
      if(this.lastKey){
        this.activities = this.activities.concat(result['data']['Items']);
      }else{
        this.activities = result['data']['Items'];
      }
      this.lastKey = result['data']['lastKey'];
    } catch (error) {
      this.globalService.statusApi(error);
    } finally {
      this.loadLog = false;
    }
  }

  async loadData() {
    if(!this.loadLog){
      let element = document.getElementById("scroll");
      if (element.offsetHeight + element.scrollTop + 5 >= element.scrollHeight) {
        if(this.lastKey){
          this.getLog();
        }
      }
    }
  }
}
